import { ReactNode } from 'react'

const NotificationSkeleton = (): ReactNode => (
  <div className="h-[80px] w-full animate-pulse bg-skeleton-primary" />
)

const NotificationsListSkeleton = (): ReactNode => (
  <div className="flex w-full flex-col items-center justify-center gap-3 bg-background-secondary px-6 py-4">
    <NotificationSkeleton />
    <NotificationSkeleton />
    <NotificationSkeleton />
  </div>
)

export default NotificationsListSkeleton
